import { render } from "./Cadastrar.vue?vue&type=template&id=7b9c1a92&scoped=true"
import script from "./Cadastrar.vue?vue&type=script&lang=js"
export * from "./Cadastrar.vue?vue&type=script&lang=js"

import "./Cadastrar.vue?vue&type=style&index=0&id=7b9c1a92&scoped=true&lang=css"
import "./Cadastrar.vue?vue&type=style&index=1&id=7b9c1a92&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9c1a92"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QForm,QBtn,QTable,QImg,QTr,QTd,QInput,QField});
